import { render, staticRenderFns } from "./HNLaureano2.vue?vue&type=template&id=b8caa45e&scoped=true"
import script from "./HNLaureano2.vue?vue&type=script&lang=js"
export * from "./HNLaureano2.vue?vue&type=script&lang=js"
import style0 from "./HNLaureano2.vue?vue&type=style&index=0&id=b8caa45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8caa45e",
  null
  
)

export default component.exports